import { getStore } from "trim-redux";

export const ALL_INDUSTRIES = ["restaurants", "markets"];
export const DEFAULT_INDUSTRY = "restaurants";

export function normalizeIndustry(value) {
    return ALL_INDUSTRIES.includes(value) ? value : DEFAULT_INDUSTRY;
}

export function getDefaultIndustry(setting) {
    const source =
        setting && typeof setting === "object" && !Array.isArray(setting)
            ? setting
            : getStore("setting");
    return normalizeIndustry(source?.default_industry);
}

export function getOrderedIndustries(setting) {
    const defaultIndustry = getDefaultIndustry(setting);
    return [defaultIndustry, ...ALL_INDUSTRIES.filter((item) => item !== defaultIndustry)];
}

export function getOtherIndustry(setting) {
    const defaultIndustry = getDefaultIndustry(setting);
    return ALL_INDUSTRIES.find((item) => item !== defaultIndustry) || DEFAULT_INDUSTRY;
}
